<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed } from 'vue';

type ExtendedParams = ICellRendererParams & {
    title: (params: ICellRendererParams) => string;
    disabled: (params: ICellRendererParams) => boolean;
    rowIndex: number;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const title = computed(() => (typeof props.params.title === 'function' ? props.params.title(props.params) : props.params.title));
const disabled = computed(() => (typeof props.params.disabled === 'function' ? props.params.disabled(props.params) : props.params.disabled));

function startEdit(): void {
    if (props.params.column == null) return;
    props.params.api.startEditingCell({
        rowIndex: props.params.rowIndex,
        colKey: props.params.column
    });
}
</script>

<template>
    <div v-if="disabled" class="flex-container align-middle height-100">
        <p>{{ title }}</p>
    </div>
    <button v-else :class="['flex-container height-100 width-100 align-middle', {'align-right': title != null}]" @click="startEdit">
        <p class="sy-truncate">{{ title }}</p>
        <div><Icon icon="edit" /></div>
    </button>
</template>
